import { Controller } from "@hotwired/stimulus"

const SHORT_MAX_HOURS = 35

export default class extends Controller {
  static targets = ["formationCombobox", "formationInput", "trainingName", "contactCombobox", "contactWrapper"]

  connect() {
    const checked = this.element.querySelector('input[name*="deal_type"]:checked')
    if (checked) this.updateFormationFilter(checked.value)
  }

  validateForm(event) {
    this.#syncTrainingName()

    let valid = true
    const form = this.element

    form.querySelectorAll("select[required]").forEach(select => {
      const combobox = select.closest("[data-controller='combobox']")
      const field = combobox ? combobox.querySelector("input") : select
      if (!select.value) {
        field?.classList.add("field-invalid")
        if (valid) field?.focus()
        valid = false
      } else {
        field?.classList.remove("field-invalid")
      }
    })

    form.querySelectorAll("input[required]").forEach(field => {
      if (!field.value) {
        field.classList.add("field-invalid")
        if (valid) field.focus()
        valid = false
      } else {
        field.classList.remove("field-invalid")
      }
    })

    if (this.hasFormationInputTarget && this.hasTrainingNameTarget) {
      const productSelect = form.querySelector("select[name='deal[dendreo_product_id]']")
      const hasProduct = productSelect && productSelect.value
      const hasTrainingName = this.trainingNameTarget.value.trim()
      const inputField = this.formationInputTarget
      if (!hasProduct && !hasTrainingName) {
        inputField.classList.add("field-invalid")
        if (valid) inputField.focus()
        valid = false
      } else {
        inputField.classList.remove("field-invalid")
      }
    }

    if (!valid) event.preventDefault()
  }

  #syncTrainingName() {
    if (!this.hasFormationInputTarget || !this.hasTrainingNameTarget) return
    const productSelect = this.element.querySelector("select[name='deal[dendreo_product_id]']")
    if (productSelect && productSelect.value) {
      this.trainingNameTarget.value = ""
    } else {
      this.trainingNameTarget.value = this.formationInputTarget.value.trim()
    }
  }

  onTypeChange(event) {
    this.updateFormationFilter(event.target.value)
  }

  updateFormationFilter(dealType) {
    if (!this.hasFormationComboboxTarget) return
    const combobox = this.formationComboboxTarget
    const base = combobox.dataset.comboboxUrlValue.split("?")[0]
    if (dealType) {
      combobox.dataset.comboboxUrlValue = `${base}?deal_type=${dealType}`
    } else {
      combobox.dataset.comboboxUrlValue = base
    }
  }

  async accountSelected(event) {
    const { id } = event.detail
    if (!this.hasContactWrapperTarget) return

    if (!id) {
      this.#renderCombobox("")
      return
    }

    try {
      const response = await fetch(`/contacts/search.json?account_id=${id}`)
      if (!response.ok) return
      const contacts = await response.json()
      this.#renderContactSelect(contacts)
    } catch (error) {
      console.error("[DealForm] Error fetching contacts:", error)
    }
  }

  #renderContactSelect(contacts) {
    const wrapper = this.contactWrapperTarget
    let html = '<select name="deal[contact_id]" class="select" required>'
    html += '<option value="">Sélectionner un contact</option>'
    contacts.forEach(c => {
      html += `<option value="${c.id}">${this.#escapeHtml(c.name)}</option>`
    })
    html += '</select>'
    wrapper.innerHTML = html
  }

  #renderCombobox(accountId) {
    const wrapper = this.contactWrapperTarget
    const url = accountId ? `/contacts/search.json?account_id=${accountId}` : '/contacts/search.json'
    wrapper.innerHTML = `
      <div class="relative" data-controller="combobox" data-combobox-url-value="${url}">
        <input type="text" placeholder="Rechercher un contact..." autocomplete="off"
               class="input" data-combobox-target="input"
               data-action="input->combobox#search focus->combobox#search">
        <select name="deal[contact_id]" class="hidden" required data-combobox-target="select">
          <option value=""></option>
        </select>
      </div>
    `
  }

  #escapeHtml(text) {
    const div = document.createElement('div')
    div.textContent = text
    return div.innerHTML
  }
}
